import { render } from "./ProductsCard.vue?vue&type=template&id=e51a2a30&scoped=true"
import script from "./ProductsCard.vue?vue&type=script&lang=js"
export * from "./ProductsCard.vue?vue&type=script&lang=js"

import "./ProductsCard.vue?vue&type=style&index=0&id=e51a2a30&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e51a2a30"]])

export default __exports__